var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16Z",
    fill: "#0078D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2725 7.02127C12.2859 6.82983 12.9501 7.97261 13.4556 8.76106C13.9476 9.52683 14.553 10.4253 14.3087 11.422C14.1727 11.9812 13.6672 12.286 13.2851 12.616C12.9081 12.9418 12.3338 13.2407 12.1944 13.7411C11.9669 14.5531 12.4648 15.4053 12.7729 15.8907C13.4732 16.9873 14.3196 17.9755 15.4003 18.858C15.9234 19.2863 16.6497 19.8581 17.3777 19.7111C18.465 19.4911 18.7522 18.1502 19.9361 17.9713C21.063 17.8009 21.8254 18.6179 22.4618 19.1654C23.0748 19.6952 24.0639 20.3736 23.9967 21.2813C23.9573 21.8027 23.5391 22.126 23.1764 22.4409C22.8078 22.7625 22.4845 23.1235 22.1201 23.3612C21.2376 23.9372 20.1553 24.2193 18.9126 24.1807C17.6942 24.1429 16.7236 23.7289 15.8428 23.2596C14.1206 22.341 12.7595 21.0487 11.4773 19.6087C10.2162 18.193 9.05155 16.517 8.40753 14.6639C7.60397 12.3498 8.02884 9.9727 9.32948 8.48985C9.54947 8.23795 9.89709 7.97513 10.2153 7.70476C10.5327 7.43355 10.8266 7.10524 11.2725 7.02127Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.547983f696814651324f3a394bb304dd.svg";
export { ForwardRef as ReactComponent };